import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const subscribeToNewsletter = createAppAsyncThunk(
  'newsLetter/subscribe',
  async (payload: SubscribeToNewsLetterPayload, { rejectWithValue, extra: { newsletterService } }) => {
    try {
      return await newsletterService.subscribeToNewsletter(payload);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type SubscribeToNewsLetterPayload = {
  email: string;
  storeId: string;
}
